import React from 'react';

const Card = ({ children, className = 'h-100', color = '' }) => {
  return (
   <div className={`card-box ${className} ${color}`}>
     <div className="card-body">
      {children}
     </div>
   </div>
  )
}

export default Card;